<template>
  <div class="fixed-banner">
    <drawer :isActive="showDrawer" @closed="showDrawer = false"></drawer>
    <div class="container-fluid mobile-banner" :style="mobileStyles.TitleBar">
      <div class="row">
        <div class="col-7 shop-title">
          <router-link to="/" class="text-white">
            <i @click.prevent="hClick" class="material-icons md-36">menu</i>
          </router-link>
        </div>
        <div class="col-5 cart" v-if="currentstore">
          <span class="cart">
            <router-link
              :to="{
                name: 'shoppingcartmobile',
                params: { storeid: currentstore,storename:$route.params.storename }
              }"
            >
              <span class="cart-cost">{{ cartValue | formatMoney }}</span>
              <i class="material-icons md-36">shopping_cart</i>
            </router-link>
          </span>
        </div>
      </div>
    </div>
    <!-- /banner -->
    <div class="container-fluid category-naviagtion intro" :style="getStyle()">
      <div class="row">
        <ul class="store-menu-mobile">
          <li class>
            <a href="#">{{ $t('message.orderOnline') }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Drawer from "../shared/drawer";
export default {
  name: "IntroHeaderMobile",
  components: {
    Drawer
  },
  data() {
    return {
      showDrawer: false
    };
  },
  computed: {
    ...mapGetters(["cartValue", "currentstore", "mobileStyles"])
  },
  methods: {
    hClick() {
      this.showDrawer = true;
    },
    getStyle() {
      var styles = [];
      styles.push(this.mobileStyles.primaryBackgroundColour);
      return styles;
    }
  }
};
</script>
